import * as actions from './actions'
import * as getters from './getters'
import * as types from '../mutation-types'

const state = {
  vacanciesLoadingTimeout: undefined,
  vacanciesLoading: false,
  companiesLoadingTimeout: undefined,
  companiesLoading: false,
  toggleLoginAlert: {
    isShow: false,
    isSucceeded: false
  },
  toggleLoginModal: false,
  toggleUserSidebar: false,
  toggleMenuSidebar: false,
  toogleUserEditResumeTextareaDialog: false,
  userAuthTouchTimestamp: 0,
  companyAuthTouchTimestamp: 0
}

const mutations = {
  [types.TOGGLE_LOGIN_ALERT] (state, data) {
    state.toggleLoginAlert = data
  },
  [types.TOGGLE_LOGIN_MODAL] (state, data) {
    state.toggleLoginModal = !!data
  },
  [types.TOGGLE_MENU_SIDEBAR] (state, data) {
    state.toggleMenuSidebar = !!data
  },
  [types.TOGGLE_USER_SIDEBAR] (state, data) {
    state.toggleUserSidebar = !!data
  },
  [types.VACANCIES_LOADING] (state, data) {
    state.vacanciesLoading = data
  },
  [types.VACANCIES_LOADING_TIMEOUT] (state, data) {
    state.vacanciesLoadingTimeout = data
  },
  [types.COMPANIES_LOADING] (state, data) {
    state.companiesLoading = data
  },
  [types.COMPANIES_LOADING_TIMEOUT] (state, data) {
    state.companiesLoadingTimeout = data
  },
  [types.TOGGLE_USER_EDIT_RESUME_TEXTAREA_DIALOG] (state, data) {
    state.toogleUserEditResumeTextareaDialog = !!data
  },
  [types.USER_AUTH_TOUCH_TIMESTAMP] (state) {
    state.userAuthTouchTimestamp = Date.now()
  },
  [types.COMPANY_AUTH_TOUCH_TIMESTAMP] (state) {
    state.companyAuthTouchTimestamp = Date.now()
  }
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/utilities/store.js